"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ICloudflareDomainType = exports.ICloudflareDomainStatus = void 0;
var ICloudflareDomainStatus;
(function (ICloudflareDomainStatus) {
    ICloudflareDomainStatus["PENDING"] = "pending";
})(ICloudflareDomainStatus = exports.ICloudflareDomainStatus || (exports.ICloudflareDomainStatus = {}));
var ICloudflareDomainType;
(function (ICloudflareDomainType) {
    ICloudflareDomainType["FULL"] = "full";
    ICloudflareDomainType["FLEXIBLE"] = "flexible";
})(ICloudflareDomainType = exports.ICloudflareDomainType || (exports.ICloudflareDomainType = {}));
